/** @format */
import { CardBackgroundColor } from './types';

export const getBackgroundColour = (color?: CardBackgroundColor) => {
    switch (color) {
        case CardBackgroundColor.MIDNIGHT:
            return 'var(--colors-surface-inverse)';
        case CardBackgroundColor.PINK:
            return 'var(--colors-brand-secondary)';
        case CardBackgroundColor.SUSTAINABILITY:
            return 'var(--colors-sustainability)';
        case CardBackgroundColor.WHITE:
        default:
            return 'var(--colors-surface-primary)';
    }
};
